import { Helmet } from 'react-helmet'
import ClearFiltersButton from 'components/common/clearFiltersButton'
import {
  NewSapBarcodeExportButton,
  NewSapBarcodeFilterForm,
  NewSapBarcodeTable,
} from 'components/newSapBarcode'
import { FILTER_FIELD_NEW_SAP_BARCODE } from 'components/newSapBarcode/utils'

const NewSapBarcodePage = () => {
  return (
    <>
      <Helmet>
        <title>GAG Aggregator | New SAP Barcode</title>
      </Helmet>

      <div className="flex items-center justify-between gap-2">
        <div className="title">New SAP Barcode</div>

        <div className="flex flex-wrap items-center justify-end gap-1">
          <ClearFiltersButton filterKey={FILTER_FIELD_NEW_SAP_BARCODE} />

          <NewSapBarcodeExportButton />
        </div>
      </div>

      <NewSapBarcodeFilterForm />
      <NewSapBarcodeTable />
    </>
  )
}

export default NewSapBarcodePage
